import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import useExecScripts from '../Component/useExecScripts'
import EnquiryForm from '../Component/EnquiryForm'
import EnquiryHeading from '../Component/EnquiryHeading'

function Services() {


	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="348" className="elementor elementor-348">
										<div className="elementor-element elementor-element-643cc4b e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="643cc4b" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-6e3e59f e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="6e3e59f" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="e-con-inner">
													<div className="elementor-element elementor-element-233d762 elementor-widget__width-inherit wpr-dual-heading-icon-top elementor-widget elementor-widget-wpr-dual-color-heading" data-id="233d762" data-element_type="widget" data-e-type="widget" data-widget_type="wpr-dual-color-heading.default">
														<div className="elementor-widget-container">
															<div className="wpr-dual-heading-wrap">
																<div className="wpr-dual-title-wrap">
																	<h1 className="wpr-dual-title">
																		<span className="first">Services</span>

																	</h1>
																</div>



															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-3025b25 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="3025b25" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-0e22cc3 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="0e22cc3" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-24904e6 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="24904e6" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
													<div className="elementor-element elementor-element-2842dba elementor-widget elementor-widget-ucaddon_icon_image_content_box" data-id="2842dba" data-element_type="widget" data-e-type="widget" data-widget_type="ucaddon_icon_image_content_box.default">
														<div className="elementor-widget-container">
<div className="uc_icon_image_content_box" id="uc_icon_image_content_box_elementor_2842dba">
																<div className="uc_content_box_area">



																	<div className="uc_thumb">
																		<Link to="/wedding-events">
																			<img decoding="async" src="/assets/images/03/CNC05428-scaled.jpg" alt="CNC05428" />
																		</Link>
																	</div>
																	<div className="uc_details">
																		<span className="uc_details-icon" aria-hidden="true">
																			<i className="fas fa-gift"></i>							</span>
																		<div className="uc_text">WEDDING EVENTS &amp; DECOR</div>			<Link className="uc_btn" to="/wedding-events">Show More</Link>		</div>
																</div>
															</div>
															{/* end Icon Image Content Box */}				</div>
													</div>
												</div>
											</div>
											<div className="elementor-element elementor-element-23ee62e e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="23ee62e" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-c7b0019 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="c7b0019" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
													<div className="elementor-element elementor-element-3b0deeb elementor-widget elementor-widget-ucaddon_icon_image_content_box" data-id="3b0deeb" data-element_type="widget" data-e-type="widget" data-widget_type="ucaddon_icon_image_content_box.default">
														<div className="elementor-widget-container">
<div className="uc_icon_image_content_box" id="uc_icon_image_content_box_elementor_3b0deeb">
																<div className="uc_content_box_area">



																	<div className="uc_thumb">
																		<Link to="/social-events">
																			<img decoding="async" src="/assets/images/03/ANI07818-scaled.jpg" alt="ANI07818" />
																		</Link>
																	</div>
																	<div className="uc_details">
																		<span className="uc_details-icon" aria-hidden="true">
																			<i className="fas fa-gift"></i>							</span>
																		<div className="uc_text">Social Events</div>			<Link className="uc_btn" to="/social-events">Show More</Link>		</div>
																</div>
															</div>
															{/* end Icon Image Content Box */}				</div>
													</div>
												</div>
											</div>
											<div className="elementor-element elementor-element-fa71a4f e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="fa71a4f" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-0de7bae e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="0de7bae" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
													<div className="elementor-element elementor-element-fa0a3a2 elementor-widget elementor-widget-ucaddon_icon_image_content_box" data-id="fa0a3a2" data-element_type="widget" data-e-type="widget" data-widget_type="ucaddon_icon_image_content_box.default">
														<div className="elementor-widget-container">
<div className="uc_icon_image_content_box" id="uc_icon_image_content_box_elementor_fa0a3a2">
																<div className="uc_content_box_area">



																	<div className="uc_thumb">
																		<Link to="/corporate-events">
																			<img decoding="async" src="/assets/images/03/ANI07906-scaled.jpg" alt="ANI07906" />
																		</Link>
																	</div>
																	<div className="uc_details">
																		<span className="uc_details-icon" aria-hidden="true">
																			<i className="fas fa-gift"></i>							</span>
																		<div className="uc_text">CORPORATE EVENTS</div>			<Link className="uc_btn" to="/corporate-events">Show More</Link>		</div>
																</div>
															</div>
															{/* end Icon Image Content Box */}				</div>
													</div>
												</div>
											</div>
											<div className="elementor-element elementor-element-9ca323a e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="9ca323a" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-e228e41 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="e228e41" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
													<div className="elementor-element elementor-element-4bf8a9f elementor-widget elementor-widget-ucaddon_icon_image_content_box" data-id="4bf8a9f" data-element_type="widget" data-e-type="widget" data-widget_type="ucaddon_icon_image_content_box.default">
														<div className="elementor-widget-container">
<div className="uc_icon_image_content_box" id="uc_icon_image_content_box_elementor_4bf8a9f">
																<div className="uc_content_box_area">



																	<div className="uc_thumb">
																		<Link to="/canteen">
																			<img decoding="async" src="/assets/images/03/CNC07032-scaled.jpg" alt="CNC07032" />
																		</Link>
																	</div>
																	<div className="uc_details">
																		<span className="uc_details-icon" aria-hidden="true">
																			<i className="fas fa-gift"></i>							</span>
																		<div className="uc_text">Canteen</div>			<Link className="uc_btn" to="/canteen">Show More</Link>		</div>
																</div>
															</div>
															{/* end Icon Image Content Box */}				</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-1f1e75f5 e-con-full e-flex e-con e-parent" data-id="1f1e75f5" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-945c812 e-flex e-con-boxed e-con e-child" data-id="945c812" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="e-con-inner">
													<div className="elementor-element elementor-element-5de87e7 e-con-full e-flex e-con e-child" data-id="5de87e7" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
																												<EnquiryHeading widgetElementId="3a077372" />

														<div className="elementor-element elementor-element-33beb559 elementor-widget" data-id="33beb559" data-element_type="widget" data-e-type="widget">
															<div className="elementor-widget-container">
<EnquiryForm />

															</div>
														</div>
													</div>
												</div>
											</div>
										</div>


									</div>{/* .entry-content</div> */}
								</div>
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default Services

